import { SummaryCard } from '@/components/shared/SummaryCard';
import { useFormContext } from 'react-hook-form';

export const ProjectSummary = ({ data, projectType }: any) => {
  const { name, startDate, endDate, boundaryExtent, description } = data;

  const { getValues } = useFormContext();
  const formValues = getValues();

  // Format dates cleanly
  const dateStr =
    formValues.startDate && formValues.endDate
      ? `${new Date(formValues.startDate).toLocaleDateString()} → ${new Date(
          formValues.endDate,
        ).toLocaleDateString()}`
      : null;

  return (
    <SummaryCard
      title="Project Summary"
      sections={[
        {
          items: [
            { label: 'Project Name', value: formValues.name || 'N/A' },
            { label: 'Project Type', value: projectType?.name },
            { label: 'Timeline', value: dateStr },
            {
              label: 'Boundary',
              value: boundaryExtent ? 'Defined' : 'Not Defined',
              className: boundaryExtent ? 'text-green-600' : 'text-yellow-600',
            },
            {
              label: 'Description',
              value: formValues.description,
            },
          ],
        },
      ]}
    />
  );
};
